import React from 'react';

const Quickstart = ({ onSectionChange }) => {
  return (
    <div className="doc-content">
      {/* Quickstart页面不显示任何内容，只用于展开子目录 */}
    </div>
  );
};

export default Quickstart;
